import log from 'loglevel'
import axios from 'axios'

import Cache from '@/syslic/utils/cache'

/* eslint class-methods-use-this: ["off"] */

export default class DeliveryStatus {
  constructor() {
    log.info('[INFO] Initialize Delivery Status Module')
    this.cache = new Cache()
  }

  fetchAllDeliveryStatus(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/order/delivery/status/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch delivery status')
            resolve(response)
          })
          .catch(error => {
            log.error('[ERROR] Fail to fetch delivery status')
            log.error(error)
            reject(error.response)
          })
      })

      return promise
    })

    return result
  }

  fetchDeliveryStatus(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/order/delivery/status/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch delivery status')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch delivery status')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateDeliveryStatus(id, deliveryData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/order/delivery/status/${id}/`, deliveryData)
        .then(response => {
          log.debug('[DEBUG] Success to update delivery status')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update delivery status')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addDeliveryStatus(deliveryData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/order/delivery/status/', deliveryData)
        .then(response => {
          log.debug('[DEBUG] Success to add delivery status')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add delivery status')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deleteDeliveryStatus(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/order/delivery/status/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete delivery status')
          this.cache.reset()
          resolve()
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete delivery status')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
